<script lang="ts">
    import type { Snippet } from "svelte";
    import { Footer, Header, Hero, Partners } from "./index.js";

    interface Props {
        layout: {
            title?: string;
        };
        children: Snippet;
    }

    let { layout = {}, children }: Props = $props();
</script>

<svelte:head>
    <title>{layout?.title}</title>
</svelte:head>


    <Hero />
    <Header homepage={true} />

    <main class="container mx-auto my-12 px-4">
        {@render children()}
    </main>

    <Partners />

    <Footer homepage={true} />

